import { apply, continueOrElse } from "core/utils";
import { displayError } from "core/utils/modals";
import useSession from "hooks/use-session";
import { useState } from "react";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import withRouting, { useRouting } from "../../../../hooks/with-routing";
import LoginForm, { FormaLogin } from "../components/login.form";

const useLogin = () => {
	const signin = useSession.use.signin();
	const segment = useRouting.use.currentSegment();
	const [cargandoDatos, setCargandoDatos] = useState(false);
	const navigate = usePathNavigate();

	const iniciarSesion = (forma: FormaLogin) => {
		setCargandoDatos(true);

		const credenciales = { ...forma, segment };

		signin(credenciales)
			.then(continueOrElse("El nombre de usuario o contraseña son incorrectos"))
			.then(apply<string>(navigate, "/:segmento/"))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	return {
		cargandoDatos,
		iniciarSesion
	};
};

const LoginPage = () => {
	const {
		cargandoDatos,
		iniciarSesion
	} = useLogin();

	return (
		<div className="vh-100 d-flex justify-content-center align-items-center">
			<div className="container">
				<div className="row d-flex justify-content-center">
					<div className="col-12 col-md-8 col-lg-5">
						<div className="card card-login">
							<div className="card-body p-5">
								<LoginForm loading={cargandoDatos} onSignIn={iniciarSesion}></LoginForm>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default withRouting(LoginPage, "/404");